import { Component, OnInit, Input, ViewChild, Output, EventEmitter } from '@angular/core';
import { trigger, state, style, transition, animate, keyframes } from '@angular/animations';

@Component({
  selector: 'app-form-page',
  templateUrl: './form-page.component.html',
  styleUrls: ['./form-page.component.css'],
  animations: [
    trigger('flyInOut', [
      state('forward', style({ transform: 'translateX(0)' })),
      state('backward', style({ transform: 'translateX(0)' })),
      transition('void => forward', [
        style({ transform: 'translateX(100%)' }),
        animate(800)
      ]),
      transition('void => backward', [
        style({ transform: 'translateX(-100%)' }),
        animate(800)
      ])
    ])
  ]
})
export class FormPageComponent implements OnInit {
  @Input() fields: any;
  @Input() currentPage: number;
  @Input() activePages: any[];
  @Input() venueSetting: any;
  @Input() pageState: string;
  @Input() country: string;
  @Output() next = new EventEmitter<any>();
  @Output() prev = new EventEmitter<any>();
  @Output() doSubmit = new EventEmitter<any>();

  constructor() { }

  ngOnInit() {
    // console.log(this.fields);
    // console.log(this.currentPage);
  }

  getFieldByName(fields: any, fieldName: string) {
    let field = false;
    if (fields.length > 0) {
      field = fields.filter(f => f.bepoz_field_name == fieldName)[0];
    }
    return field;
  }
  getActiveFields (fields: any) {
    let field = false;
    if (fields.length > 0) {
      field = fields.filter(f => f.active && f.page == this.currentPage && f.bepoz_field_name !== 'CardNumber' && f.field_type !== 'boolean');
    }
    return field;
  }
  getBoolActiveFields (fields: any) {
    let field = false;
    if (fields.length > 0) {
      field = fields.filter(f => f.active && f.page == this.currentPage && f.field_type === 'boolean');
    }
    return field;
  }
  filterFields(fields: any, filter: any[]) {
    if (fields.length < 0) {
      return [];
    }
    return fields.filter(f => {
      return f.active && filter.indexOf(f.field_type)>=0
    });
  }

  getAddComponentByType(address: any, type: string) {
    let AddComponentArray = address.address_components.filter(ac => {
      return ac.types.indexOf(type) >= 0;
    });

    if (AddComponentArray.length) {
      return AddComponentArray[0];
    }
    return null;
  }

  preBtns(btnName:string){
    this[btnName].emit();
  }

  addressOnChange(address) {
    // console.log(address);
    const AddComponents = ['Street1', 'Street2', 'City', 'State', 'PCode'];

    AddComponents.forEach(field => {
      if (this.getFieldByName(this.fields['general_fields'], field)['active']) {
        if (field === 'Street1') {
          this.getFieldByName(this.fields['general_fields'], field)['value'] = this.getAddComponentByType(address, 'subpremise') ? this.getAddComponentByType(address, 'subpremise').short_name : '';
        }
        if (field === 'Street2') {
          this.getFieldByName(this.fields['general_fields'], field)['value'] = this.getAddComponentByType(address, 'street_number') ? this.getAddComponentByType(address, 'street_number').short_name : '';
          this.getFieldByName(this.fields['general_fields'], field)['value'] = this.getFieldByName(this.fields['general_fields'], field)['value'] + ' '+ (this.getAddComponentByType(address, 'route') ? this.getAddComponentByType(address, 'route').short_name : '');
        }
        if (field === 'City') {
          if (this.country === 'United Kingdom') {
            this.getFieldByName(this.fields['general_fields'], field)['value'] = this.getAddComponentByType(address, 'postal_town') ? this.getAddComponentByType(address, 'postal_town').long_name : '';
          } else {
            this.getFieldByName(this.fields['general_fields'], field)['value'] = this.getAddComponentByType(address, 'locality') ? this.getAddComponentByType(address, 'locality').short_name : '';
          }
        }
        if (field === 'State') {
          if (this.country === 'United Kingdom') {
            this.getFieldByName(this.fields['general_fields'], field)['value'] = this.getAddComponentByType(address, 'administrative_area_level_2') ? this.getAddComponentByType(address, 'administrative_area_level_2').short_name : '';
          } else {
            this.getFieldByName(this.fields['general_fields'], field)['value'] = this.getAddComponentByType(address, 'administrative_area_level_1') ? this.getAddComponentByType(address, 'administrative_area_level_1').short_name : '';
          }
        }
        if (field === 'PCode') {
          this.getFieldByName(this.fields['general_fields'], field)['value'] = this.getAddComponentByType(address, 'postal_code') ? this.getAddComponentByType(address, 'postal_code').short_name : '';
        }
      }
    });
  }

}
